
























































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import AMSformTable from '@/components/AMSformTable.vue';
import AMSDialog from '@/components/AMSDialog.vue';
import {
  putShip,
  deleteShip,
  shipSettlementStatus,
  getShipStatusColor,
  getShipCompanyName,
  shipCompany,
  getShipStatusName,
  shipStatus,
  shipList,
  ship,
  mergeShip,
  cancelShip,
  batchCancelShip,
  checkMergeShip,
  cancel,
  batchCancel,
  logistics,
  shipBySf,
  shipMergeBySf,
  exportShipment
} from '@/api/shipment';
import { AppStore } from '@/store/modules/app';
import { VAlert } from 'vuetify/lib';
import { emptyRule, rangeLengthRule, specialCharRule } from '@/utils/rules';
import utils from '@/utils/utils';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import moment from 'moment';
import { getModuleName } from '@/utils/utils';
import Logistics from '@/views/orderManage/shipmentsManagement/logisticsManageList.vue';
import ShipButton from '@/views/orderManage/shipmentsManagement/shipButton.vue';
Vue.component('ShipButton', ShipButton);
import { confirmCancelGiveOut } from '@/api/materials';
import ShipInfoManagerList from '@/views/orderManage/shipmentsManagement/shipInfoMangeList.vue';
@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-dialog': AMSDialog,
    'ams-breadcrumb': AMSBreadcrumb,
    'logistics-manage-list': Logistics,
    'ship-info-manager-list': ShipInfoManagerList
  }
})
export default class ShipmentManagement extends Vue {
  valid: Boolean = true;
  FilterItem = [
    { name: '全部', id: '', count: 'totalCount' },
    { name: '订单', id: 'customerOrder', count: 'customerOrderCount' },
    { name: '物料申请单', id: 'materialOrder', count: 'materialOrderCount' }
  ];
  quantityRules = [
    (value: any) => !!value || '件数不能为空',
    (value: any) => (value && value !== '0') || '件数不能为0',
    (value: any) => (value && Number(value) <= 50) || '件数不能超过50个'
  ];
  // [(value: any) => (value && value!==0) || '件数不能为0',emptyRule('件数')]
  /**发货信息管理弹窗 */
  showManagerShipInfoDialog: boolean = false;
  showConfirmDeleteLastShipDialog: boolean = false;
  /**自行发货 */
  selfLogistics: any[] = [];
  /**顺丰发货 */
  sfLogistics: any[] = [];
  /**是否是继续发货 */
  isContinuteShip: boolean = false;

  /**顺丰寄件弹窗 */
  showShunfengShipDialog: boolean = false;
  showZhongTongShipDialog: boolean = false;
  shipByZTValid: boolean = true;
  /**顺丰寄件结算方式 */
  shipSettlementStatusItems: any[] = [...shipSettlementStatus];
  parcelQuantity = '1'; //寄件件数
  /**当前选择的结算方式 默认是到付现结*/
  shipSettlementStatus: string = 'DeliverFeeToBeCollected';
  shufengLoading: boolean = false;
  zhongTongLoading: boolean = false;
  api: string = '/api/Shipment/ShipList';
  form: any = {
    filter: '',
    status: '',
    orderStartTime: '',
    orderEndTime: ''
  };
  /**选中的记录 */
  selected: any[] = [];
  selectAll: boolean = true;
  /**物流信息 */
  logistics: any[] = [
    {
      company: '',
      number: ''
    }
  ];
  shipActionItems: any[] = ['输入发货信息', '顺丰寄件', '中通寄件'];

  showMergeShipMenu: boolean = false;
  /**开始时间选择器 */
  startTimeMenu: boolean = false;
  /**结束时间选择器 */
  endTimeMenu: boolean = false;
  /**面包屑 */
  breadItems = [
    {
      text: '订单管理',
      disabled: false,
      href: 'shipmentManagement'
    },
    {
      text: '发货列表',
      disabled: true
    }
  ];
  showInfoDialog: boolean = false;
  /**物流信息弹窗 */
  logisticsDialog: boolean = false;
  /**物流状态 */
  items: any[] = [{ key: '', value: '全部' }, ...shipStatus];
  /**物流公司 */
  shipItems: any[] = [...shipCompany];
  /**发货时间选择器 */
  menu: boolean = false;
  /**当前时间 */
  currentTime: string = new Date().toISOString().substr(0, 10);
  headers: object[] = [
    {
      isSelectAll: (props: any) => {
        return props.item.status === 'Cancel';
      },
      width: 60,
      align: 'left'
    },
    {
      text: '出库单',
      align: 'left',
      sortable: false,
      width: 140,
      value: 'stockNumber',
      render: (h: any, params: any) => {
        return h('div', { ...utils.stausRenderDiableColor(params.row.status) }, params.row.stockNumber);
      }
    },
    {
      text: '关联订单编号/关联申请单编号',
      align: 'left',
      sortable: false,
      width: 140,
      value: 'orderNumber',
      render: (h: any, params: any) => {
        return h('div', { ...utils.stausRenderDiableColor(params.row.status) }, params.row.orderNumber);
      }
    },
    {
      text: '客户信息',
      align: 'left',
      width: 150,
      sortable: false,
      render: (h: any, params: any) => {
        return h(
          'div',
          {
            //样式
            ...utils.stausRenderDiableColor(params.row.status)
          },
          `${params.row.customerName || ''} ${params.row.customerPhone || ''}`
        );
      }
    },
    {
      text: '物流单号',
      align: 'left',
      sortable: false,
      width: 100,
      value: 'stockNumber',
      render: (h: any, params: any) => {
        const ret: any = [];
        let parent: any = {};
        const cb = (arr: any) => {
          arr.forEach((item: any) => {
            if (item.numbers) {
              parent = item;
              cb(item.numbers);
            } else {
              ret.push({ num: item, id: parent.id });
            }
          });
        };
        cb(params.row.logistics);
        const children = ret;
        return h(
          'div',
          ret.map((r: any, idx: number) => {
            return h(
              'button',
              {
                style: {
                  color: '#1abc9c',
                  margin: '5px',
                  display: 'block',
                  ...utils.stausRenderDiableColor(params.row.status)
                },
                on: {
                  click: () => {
                    this.onViewLogisticsClick(r);
                  }
                }
              },
              r.num
            );
          })
        );
      }
    },
    {
      text: '发货/发放状态',
      align: 'left',
      sortable: false,
      value: 'status',
      width: 150,
      render: (h: any, params: any) => {
        return h(
          'div',
          {
            style: {
              color: this.switchStatus(params.row.status)!.color
            },
            class: {
              status: true
            },
            attrs: {
              'status-color': ''
            }
          },
          getShipStatusName(params.row.status)
        );
      }
    },
    {
      text: '操作',
      width: 130,
      align: 'center',
      sortable: false,
      value: 'actions',
      render: (h: any, params: any) => {
        return h('div', [
          h(
            'button',
            {
              class: {
                'action-button': true
              },
              on: {
                click: () => {
                  this.onListClick(params);
                }
              }
            },
            '查看'
          ),
          h('ShipButton', {
            props: {
              title: '发货',
              show: params.row.status === 'ToBeShip' && this.getPermission('OrderManager.ShipmentList.ShipAndCancelShip')
            },
            style: {},
            on: {
              showAddLogistics: (type: any) => {
                this.isContinuteShip = false;
                this.onShipTypeClick(type, params.row);
              },
              showShunFeng: (type: any) => {
                this.isContinuteShip = false;
                this.onShipTypeClick(type, params.row);
              }
            }
          }),
          h('ShipButton', {
            props: {
              title: '继续发货',
              show: params.row.status === 'Shipped' && this.getPermission('OrderManager.ShipmentList.ShipAndCancelShip')
            },
            style: {},
            on: {
              showAddLogistics: (type: any) => {
                this.isContinuteShip = true;
                this.onShipTypeClick(type, params.row);
              },
              showShunFeng: (type: any) => {
                this.isContinuteShip = true;
                this.onShipTypeClick(type, params.row);
              }
            }
          }),
          h(
            'button',
            {
              class: {
                'action-button': true
              },
              style: {
                display: params.row.status == 'Shipped' && this.getPermission('OrderManager.ShipmentList.ShipAndCancelShip') ? 'inline' : 'none'
              },
              on: {
                click: () => {
                  this.onShipInfoManageClick(params.row);
                }
              }
            },
            '发货信息管理'
          ),
          h(
            'button',
            {
              class: {
                'action-button': true
              },
              style: {
                display:
                  (params.row.status === 'ToBeGivenOut' || params.row.status === 'ToBeShip') && this.getPermission('OrderManager.ShipmentList.CancelAllocation') ? 'inline' : 'none'
              },
              on: {
                click: () => {
                  this.onCancelClick(params.row);
                }
              }
            },
            '取消出库'
          ),
          h(
            'button',
            {
              class: {
                'action-button': true
              },
              style: {
                display: params.row.status == 'Shipped' && this.getPermission('OrderManager.ShipmentList.ShipAndCancelShip') ? 'inline' : 'none'
              },
              on: {
                click: () => {
                  this.onCancelShipClick(params.row);
                }
              }
            },
            '取消发货'
          ),
          h(
            'button',
            {
              class: {
                'action-button': true
              },
              style: {
                display: params.row.status == 'ToBeGivenOut' && this.getPermission('OrderManager.ShipmentList.ShipAndCancelShip') ? 'inline' : 'none'
              },
              on: {
                click: () => {
                  this.grant(params.row);
                }
              }
            },
            '发放'
          ),
          h(
            'button',
            {
              class: {
                'action-button': true
              },
              style: {
                display: params.row.status === 'Receiving' && this.getPermission('OrderManager.ShipmentList.ShipAndCancelShip') ? 'inline' : 'none'
              },
              on: {
                click: () => {
                  this.cancelGrant(params.row);
                }
              }
            },
            '取消发放'
          )
        ]);
      }
    }
  ];
  totalCount: number = 1;
  datas: any[] = [{ number: '123' }];
  /**下单时间段 筛选条件 */
  dates: string[] = [];
  /**直接发货de时间 */
  date: string = new Date().toISOString().substr(0, 10);
  /**直接发货de物流公司 */
  ship: any = { key: '' };
  /**直接发货de物流单号 */
  shipNumber: string = '';
  /**物流信息 */
  shipDatas: any = {};
  /**筛选的状态 */
  type: any = this.items[0];
  /**当前选中的item */
  currentItem: any = null;
  logNumber = 50; //物流个数限制
  intData = {}; //过滤data
  lastTime = '';
  startTime = '';
  OtherDataGet(value: object) {
    this.intData = value;
  }
  /*取消发放*/
  cancelGrant(item: any) {
    confirmCancelGiveOut(item.id).then(() => {
      AppStore.ShowSuccess('取消成功！');
      (this.$refs.formtable as HTMLFormElement).query(true);
    });
  }
  /*发放*/
  grant(item: any) {
    let param = {
      shipmentIds: [item.id]
    };
    const _this = this;
    ship(param)
      .then(response => {
        AppStore.ShowSuccess('发放成功');
        (this.$refs.formtable as HTMLFormElement).query(true);
      })
      .catch(error => {});
  }

  clickFilter(id: string) {
    this.form.orderType = id;
    (this.$refs.formtable as HTMLFormElement).query(true);
  }
  /**顺丰寄件弹窗点击关闭 */
  closeShunfengShipAMSDialog() {
    this.reset();
    this.showShunfengShipDialog = false;
  }
  closeZhongTongShipAMSDialog() {
    this.reset();
    this.showZhongTongShipDialog = false;
  }
  /**顺丰寄件弹窗点击保存 */
  submitShunfengShipAMSDialog() {
    if (!(this.$refs.shipBysF as any).validate()) {
      return;
    }
    let param = {};
    let mes = '';
    if (this.currentItem) {
      param = {
        shipmentIds: [this.currentItem.id],
        parcelQuantity: Number(this.parcelQuantity),
        sfPayMethod: this.shipSettlementStatus,
        isSF: true
      };
      mes = '发起顺丰寄件成功';
    } else {
      let ids = this.selected.map(v => {
        return v.id;
      });
      param = {
        shipmentIds: ids,
        sfPayMethod: this.shipSettlementStatus,
        parcelQuantity: Number(this.parcelQuantity),
        isSF: false
      };
      mes = '发起合并顺丰寄件成功';
    }
    const _this = this;
    this.shufengLoading = true;
    AppStore.ShowWarning('生成面单中，请耐心等待', 10000);
    shipMergeBySf(param)
      .then((response: any) => {
        let timer = null;
        this.shufengLoading = false;
        AppStore.ShowSuccess(mes);
        this.showShunfengShipDialog = false;
        this.reset();
        this.refrenshData();
        let routeData = _this.$router.resolve({
          name: 'shufengPrint',
          query: { key: `${response}` }
        });
        window.open(routeData.href, '_blank');
      })
      .catch(error => {
        this.shufengLoading = false;
      });
  }

  /**中通寄件弹窗点击保存 */
  submitZhongTongShipAMSDialog() {
    if (!(this.$refs.shipBysF as any).validate()) {
      return;
    }
    let param = {};
    let mes = '';
    if (this.currentItem) {
      param = {
        shipmentIds: [this.currentItem.id],
        parcelQuantity: Number(this.parcelQuantity)
      };
      mes = '发起中通寄件成功';
    }
    const _this = this;
    this.shufengLoading = true;
    AppStore.ShowWarning('生成订单中，请耐心等待', 1000);
    shipMergeBySf(param)
      .then((response: any) => {
        this.zhongTongLoading = false;
        AppStore.ShowSuccess(mes);
        this.showZhongTongShipDialog = false;
        this.reset();
        this.refrenshData();
        let routeData = _this.$router.resolve({
          name: 'zhongtongPrint',
          query: { key: `${response}` }
        });
        window.open(routeData.href, '_blank');
      })
      .catch(error => {
        this.zhongTongLoading = false;
      });
  }

  /**发货管理 确定删除最后一条发货 点击取消*/
  closeConfirmDeleteLastShipDialog() {
    this.showConfirmDeleteLastShipDialog = false;
  }
  /**发货管理  确定删除最后一条发货 点击确定*/
  submitConfirmDeleteLastShipDialog() {
    this.showConfirmDeleteLastShipDialog = false;
    this.showManagerShipInfoDialog = false;
    this.onCancelShipClick(this.currentItem);
  }
  /**发货管理 发货信息准备删除最后一条的时候，调用取消发货接口 */
  handleCancleShip() {
    this.showConfirmDeleteLastShipDialog = true;
  }
  /**发货信息管理点击取消 */
  closeMangerShipInfoAMSDialog() {
    this.reset();
    this.refrenshData();
    this.showManagerShipInfoDialog = false;
  }
  /**发货信息管理点击保存 */
  submitMangerShipInfoAMSDialog() {
    if (this.selfLogistics.length <= 0) {
      this.refrenshData();
      this.showManagerShipInfoDialog = false;
    } else {
      this.selfLogistics.forEach(item => {
        if (item.items) {
          item.items.forEach((el: any) => {
            if (el.company === 'SelfMention') delete el.number;
          });
        }
      });
      let param = { selfLogistics: this.selfLogistics };
      putShip(param)
        .then(response => {
          AppStore.ShowSuccess('修改发货信息成功');
          this.refrenshData();
          this.showManagerShipInfoDialog = false;
        })
        .catch(error => {});
    }
  }
  /**点击了发货信息管理 */
  onShipInfoManageClick(item: any) {
    // console.log(item, '4124');
    //formatDateTimeMM
    var sl = JSON.stringify(item.selfLogistics || []);
    var n_sl = JSON.parse(sl);
    n_sl.map((v: any) => {
      v.shippedTime = this.formatDateTimeMM(v.shippedTime);
    });
    this.selfLogistics = n_sl;
    var sf = JSON.stringify(item.sfLogistics || []);
    this.sfLogistics = JSON.parse(sf);
    this.currentItem = item;
    this.showManagerShipInfoDialog = true;
  }

  formatDateTimeMM(date: any) {
    return moment(date).format('YYYY-MM-DD');
  }

  /** 根据状态返回颜色*/
  switchStatus(status: string) {
    switch (status) {
      case 'ToBeShip':
        return { color: '#FF0000', text: '待发货' };
      case 'Shipped':
        return { color: '#1abc9c', text: '已发货' };
      case 'Cancel':
        return { color: '#999999', text: '已取消' };
      case 'OrderCancel':
        return { color: '#999999', text: '订单取消' };
      case 'AlreadyReceived':
        return { color: '#1abc9c', text: '已领取' };
      case 'Receiving':
        return { color: '#FF0000', text: '待领取' };
      case 'ToBeGivenOut':
        return { color: '#FF0000', text: '待发放' };
    }
  }

  getSelected(val: any) {
    this.selected = val;
  }

  initForm() {
    this.form = {
      filter: '',
      status: '',
      operateStartTime: '',
      operateEndTime: '',
      orderType: ''
    };
    this.lastTime = '';
    this.startTime = '';
  }

  getDColor(item: any) {
    return utils.stausDiableColor(item.status);
  }

  onEnter() {
    this.$refs.BeginTimeText && (this.$refs.BeginTimeText as any).blur();
    this.$refs.EndTimeText && (this.$refs.EndTimeText as any).blur();
  }
  @Watch('lastTime', { immediate: true, deep: true })
  onStartTimeStrChange(newValue: string, oldValue: string) {
    this.form.orderEndTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('startTime', { immediate: true, deep: true })
  onEndTimeStrChange(newValue: string, oldValue: string) {
    this.form.orderStartTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('startTimeMenu', { immediate: true, deep: true })
  onBeginTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.BeginTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  @Watch('endTimeMenu', { immediate: true, deep: true })
  onEndTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.EndTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  getColor(item: any) {
    return getShipStatusColor(item.status);
  }

  /**快递单号rule */
  get shipNumberRules() {
    let rules: any[] = [];
    if (this.shipNumber) {
      if (this.shipNumber.length < 5) {
        return ['请填写5-25位的物流单号'];
      }
      return [...rules, rangeLengthRule(5, 25, '快递单号')];
    }
  }

  /**合并发货按钮的启用和禁用 */
  get disableCombineShipButton() {
    //如选择的出库单仅包含待发货时，点亮【合并发货】、【取消出库】批量操作按钮
    // 对待发货，且收件人相同（联系人、电话、地址相同）的订单，可合并发货
    // 点击合并发货时，如收件人不同，则弹出提示：收件人不一致，无法合并发货
    // 如收件人相同，则弹出选择发货方式下拉框，同单独发货时一致
    //1.7 改成已发货出库单支持继续发货
    // let disable = this.selected.length <= 0 ? true : false;
    // this.selected.map(v => {
    //   if (v.status != 'ToBeShip') {
    //     disable = true;
    //   }
    // });
    // return disable;
    let disable = this.selected.length <= 0 ? true : false;
    this.selected.map(v => {
      if (v.status !== 'ToBeShip' && v.status !== 'Shipped') {
        disable = true;
      }
    });
    return disable;
  }
  /**取消出库按钮的启用和禁用 */
  get enableCancelDeliveryButton() {
    let enable = this.selected.length <= 0 ? true : false;
    this.selected.map(v => {
      if (v.status != 'ToBeShip') {
        enable = true;
      }
    });
    return enable;
  }
  /**取消发货按钮的启用和禁用 */
  get enableCanceShiplButton() {
    //如选择的出库单仅包含已发货时，点亮【取消发货】批量操作按钮，点击取消发货时，
    // 将出库单变更状态为待发货，并且清空物流信息（发货时间、物流、物流单号）
    let enable = this.selected.length <= 0 ? true : false;
    this.selected.map(v => {
      if (v.status != 'Shipped') {
        enable = true;
      }
    });
    return enable;
  }

  /**物流信息弹窗 标题 */
  get logisticeListName() {
    return this.shipDatas && this.shipDatas.logisticsNumber ? `${getShipCompanyName(this.shipDatas.company)}:${this.shipDatas.logisticsNumber}` : '';
  }
  created() {
    this.form.orderType = '';
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
      this.startTime = this.form.orderStartTime ? moment(this.form.orderStartTime).format('YYYY-MM-DD') : '';
      this.lastTime = this.form.orderEndTime ? moment(this.form.orderEndTime).format('YYYY-MM-DD') : '';
    }
  }
  getPermission(name: string) {
    return utils.isPermission(name);
  }

  /**点击了弹窗取消按钮 */
  closeAMSDialog() {
    this.showInfoDialog = false;
    this.reset();
  }

  refrenshData() {
    (this.$refs.formtable as HTMLFormElement).query();
    (this.$refs.formtable as HTMLFormElement).clearSelected();
    this.reset();
  }

  reset() {
    this.shufengLoading = false;
    this.currentItem = null;
    (this.$refs.shipForm as any).resetValidation();
    this.ship = { key: '' };
    this.shipNumber = '';
    this.date = new Date().toISOString().substr(0, 10);
    this.logistics = [
      {
        company: '',
        number: ''
      }
    ];
    this.shipSettlementStatus = 'DeliverFeeToBeCollected';
  }

  /**合并发货弹出菜单点击事件 */
  onMergeShipTypeClick(type: string) {
    switch (type) {
      case '输入发货信息':
        this.showInfoDialog = true;
        break;
      case '顺丰寄件':
        this.parcelQuantity = '1';
        this.showShunfengShipDialog = true;
        break;
      case '中通寄件':
        this.parcelQuantity = '1';
        this.showZhongTongShipDialog = true;
        break;
      default:
        break;
    }
  }

  /**点击了自行寄件弹窗确定按钮 */
  submitAMSDialog() {
    if (!(this.$refs.shipForm as any).validate()) return;
    //合并发货this.selected.length > 0
    if (!this.currentItem && this.selected.length > 0) {
      this.onMergeShip();
    }
    //单个发货
    else {
      if (!this.currentItem) return;
      const _this = this;
      this.logistics.forEach(item => {
        if (item.company === 'SelfMention') delete item.number;
      });
      let prama: any = {
        shipmentIds: [this.currentItem.id],
        shipTime: moment(this.date)
          .utc()
          .format(),
        logistics: this.logistics
      };
      let same = moment(this.date).isSame(moment(new Date()), 'day');
      if (same) {
        prama['shipTime'] = moment(new Date())
          .utc()
          .format();
      }
      ship(prama)
        .then(response => {
          AppStore.ShowSuccess('发货成功');
          _this.showInfoDialog = false;
          _this.reset();
          _this.refrenshData();
        })
        .catch(error => {
          _this.showInfoDialog = false;
          _this.reset();
        });
    }
  }

  /**自行寄件 如果能有合并发货 就调用这个合并发货 */
  onMergeShip() {
    const _this = this;
    let ids = this.selected.map(v => {
      return v.id;
    });
    this.logistics.forEach(item => {
      if (item.company === 'SelfMention') delete item.number;
    });
    let prama = {
      shipmentIds: ids,
      shipTime: moment(this.date)
        .utc()
        .format(),
      logistics: this.logistics
    };
    let same = moment(this.date).isSame(moment(new Date()), 'day');
    if (same) {
      prama['shipTime'] = moment(new Date())
        .utc()
        .format();
    }
    mergeShip(prama)
      .then(response => {
        AppStore.ShowSuccess('合并发货成功');
        _this.showInfoDialog = false;
        _this.reset();
        _this.refrenshData();
      })
      .catch(error => {});
  }

  /**直接发货选择了物流公司 */
  onShipClick(item: any, index: number) {
    this.ship = item;
  }

  /**点击了查看清单 */
  onListClick(item: any) {
    const i = item.row;
    i.id = i.orderId;
    if (item.row.orderType === 'CustomerOrder') {
      this.$router.push({
        name: 'orderList_details',
        query: Object.assign({}, i, { tabActive: item.row.status === 'Cancel' ? 'OrderDetails' : 'Ship' }),
        params: i
      });
    } else {
      this.$router.push({
        name: 'materials_view',
        query: Object.assign({}, i, { tabActive: item.row.status === 'Cancel' ? 'materialsDetails' : 'materialsShip' }),
        params: i
      });
    }
  }

  /**点击了列表中的发货 */
  onShipTypeClick(type: string, item: any) {
    switch (type) {
      case '输入发货信息':
        this.currentItem = item;
        this.logNumber = item.logistics ? 50 - item.logistics.length : 50;
        this.showInfoDialog = true;
        break;
      case '顺丰寄件':
        (this.$refs.shipBysF as any).resetValidation();
        if (!item || !item.id) return;
        this.currentItem = item;
        this.parcelQuantity = '1';
        this.showShunfengShipDialog = true;
        break;
      case '中通寄件':
        (this.$refs.shipByZT as any).resetValidation();
        if (!item || !item.id) return;
        this.currentItem = item;
        this.parcelQuantity = '1';
        this.showZhongTongShipDialog = true;
        break;
      default:
        break;
    }
  }

  /**点击了查看物流 */
  onViewLogisticsClick(item: any) {
    logistics(item)
      .then(response => {
        this.shipDatas = response;
        if (this.shipDatas.datas) {
          this.shipDatas.datas.map((v: any) => {
            const date = new Date(v.trackTime)
              .toISOString()
              .replace(/T/g, ' ')
              .replace(/\.[\d]{3}Z/, ''); //moment(v.trackTime).format('YYYY-MM-DD HH:mm:ss')// moment(v.trackTime).format('YYYY-MM-DD HH:mm:ss') //utils.formatDateByFormat(v.trackTime, 'yyyy-MM-dd hh:mm:ss');
            v.trackTime = date;
          });
        }
        this.logisticsDialog = true;
      })
      .catch(error => {});
  }

  mounted() {}

  /**点击了筛选条件的时间段的清除按钮 */
  onDateClearClick() {
    this.$nextTick(() => {
      this.dates = [];
      (this.$refs.dateTextfield as any).blur();
    });
  }

  @Watch('dates', { immediate: true, deep: true })
  onDatesChange(value: any[], oldValue: any[]) {
    if (value.length > 2) {
      this.dates.splice(1, 1);
    }
  }

  /**点击了筛选条件的时间的确定按钮 */
  onDateSubmitClick() {
    if (this.dates.length <= 1) {
      AppStore.ShowWarning('请选择一个时间段', 2000);
    } else {
      this.dates.sort();
      (this.$refs.startTimeMenu as any).save(this.dates);
    }
  }

  /**点击了取消发货 */
  onCancelShipClick(item: any) {
    const _this = this;
    cancelShip(item.id)
      .then(response => {
        AppStore.ShowSuccess('取消发货成功');
        _this.refrenshData();
      })
      .catch(error => {});
  }

  /**点击了批量取消发货 */
  onMergeCancelShipClick() {
    if (this.selected.length <= 0) return;
    let ids = this.selected.map(v => {
      return v.id;
    });
    let param = {
      shipmentIds: ids
    };
    const _this = this;
    batchCancelShip(param)
      .then(response => {
        AppStore.ShowSuccess('批量取消发货成功');
        _this.refrenshData();
      })
      .catch(error => {});
  }
  /**点击了单个取消出库 */
  onCancelClick(item: any) {
    const _this = this;
    cancel(item.id)
      .then(response => {
        AppStore.ShowSuccess('取消出库成功');
        _this.refrenshData();
      })
      .catch(error => {});
  }

  /**点击了批量取消出库 */
  onMergeCancelClick() {
    if (this.selected.length <= 0) return;
    let ids = this.selected.map(v => {
      return v.id;
    });
    let param = {
      shipmentIds: ids
    };
    const _this = this;
    batchCancel(param)
      .then(response => {
        AppStore.ShowSuccess('批量取消出库成功');
        _this.refrenshData();
      })
      .catch(error => {});
  }

  /**寄件件数输入事件 */
  changeParcelQuantity(v: any) {
    if (v) {
      // 只能输入数字
      let t = v.replace(/\D/g, '');
      this.$nextTick(() => {
        this.parcelQuantity = t;
      });
    }
  }

  /**点击了合并发货 */
  onMergeShipClick() {
    if (this.selected.length <= 0) return;
    //先检查是否能够合并发货
    const _this = this;
    let ids = this.selected.map(v => {
      return v.id;
    });
    checkMergeShip(ids)
      .then(response => {
        _this.showMergeShipMenu = true;
      })
      .catch(error => {});
  }

  onStatusClear() {
    // this.type = { key: '', value: '全部' };
    setTimeout(() => {
      this.type = { key: '', value: '全部' };
    }, 1);
  }

  handleExport() {
    const params = Object.assign({}, this.form);
    exportShipment(params)
      .then(response => {
        AppStore.ShowSuccess('下载成功');
      })
      .catch(error => {
        AppStore.ShowError('下载失败');
      });
  }
}
